
export const CHANGE_SETTING = 'CHANGE_SETTING';
export const ACCESS_TOKEN = 'altrabo_api_token';
export const REFRESH_TOKEN = 'altrabo_refresh_token';


export function changeSetting(set) {
    return {
        type: CHANGE_SETTING,
        set
    };
}

export function setAlibabaToken(api_token, refresh_token) {
    localStorage.setItem(ACCESS_TOKEN, api_token);
    localStorage.setItem(REFRESH_TOKEN, refresh_token);
}



// WEBPACK FOOTER //
// ./src/redux/actions/setting.js